<template>
  <div class="box flex-row is_clickable" @click="$emit('select:bonusPhase', { bonusPhaseType })">
    <BaseImage :src="bonusPhaseIcon" alt="Bonus Phase" />

    <div class="bonus_txt">
      <h3>{{ bonusPhaseTitle }}</h3>

      <p>{{ bonusPhaseDescription }}</p>
    </div>

    <BaseCountdownTimer
      :end-date="bonusPhase.end"
      el-class="bonus_timer"
      timer-format="hh:mm:ss"
    />
  </div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseCountdownTimer from '@/components/timer/BaseCountdownTimer.vue';
import { getPointsDiscountImage } from '@/helpers/image.js';
import { bonusPhaseTypeEnum } from '@/constants/bonusPhase.js';
import { bundleDiscountImage } from '@/constants/image.js';

const bonusPhaseConfigurationPerType = {
  [bonusPhaseTypeEnum.BUNDLES]: {
    getIcon: () => bundleDiscountImage,
    getTitle: () => 'page_home_item_bonus_phase_bundle_discount_title',
    getDescription: () => 'page_home_item_bonus_phase_bundle_discount_description',
  },
  [bonusPhaseTypeEnum.POINTS]: {
    getIcon: ({ multiplier }) => getPointsDiscountImage(multiplier),
    getTitle: ({ multiplier }) => `page_home_item_bonus_phase_game_points_title_x${ multiplier }`,
    getDescription: ({ multiplier }) => `page_home_item_bonus_phase_game_points_description_x${ multiplier }`,
  },
};

const { proxy } = getCurrentInstance();

defineEmits(['select:bonusPhase']);

const props = defineProps({
  bonusPhase: {
    type: Object,
    default: () => ({}),
  },
});

const bonusPhaseType = computed(() => props.bonusPhase.__type);

const bonusPhaseIcon = computed(() => (bonusPhaseConfigurationPerType[bonusPhaseType.value]?.getIcon(props.bonusPhase) || ''));

const bonusPhaseTitle = computed(() => (proxy.$_translate(bonusPhaseConfigurationPerType[bonusPhaseType.value]?.getTitle?.(props.bonusPhase)) || ''));

const bonusPhaseDescription = computed(() => (proxy.$_translate(bonusPhaseConfigurationPerType[bonusPhaseType.value]?.getDescription?.(props.bonusPhase)) || ''));
</script>
